import { Button } from 'components'
import styles from './AddDocumentsButton.module.scss'

type Props = {
    onClick?: () => void
}

const AddDocumentsButton = ({onClick}: Props) => (
    <Button 
        className={styles.button}
        fillMode='flat'
        themeColor='secondary'
        onClick={onClick}
    >
        UPLOAD DOCUMENTS
    </Button>
)

export default AddDocumentsButton;